import { createSlice } from "@reduxjs/toolkit";

const liveModeSlice = createSlice({
  name: "liveMode",
  initialState: {
    isLive: false, // Initial state: Not in Live Mode
  },
  reducers: {
    enableLiveMode: (state) => {
      state.isLive = true;
    },
    disableLiveMode: (state) => {
      state.isLive = false;
    },
    toggleLiveMode: (state) => {
      state.isLive = !state.isLive;
    },
  },
});

// Export actions
export const { enableLiveMode, disableLiveMode, toggleLiveMode } =
  liveModeSlice.actions;

// Export reducer
export default liveModeSlice.reducer;
